import { Box, Text, DataTable } from 'grommet';
import { StatusGoodSmall } from 'grommet-icons';
import { FrostedGlassBox } from '../components';
import { ACTION_COLOURS } from '../constants';

const MetricsSection = ({ mappedData }) => {

  return (
    <FrostedGlassBox >
      <div class="container" >
        <Box margin={{ top: '1rem', left: '1.5rem', bottom: '1rem' }}>
          <Box margin={{ top: '0rem' }}>
            <Text
              flex='shrink'
              margin={{ vertical: 'auto' }}
              size="large"

            >{`Metrics`}</Text>
            <DataTable pad={'xxsmall'}
              columns={[
                {
                  property: 'name',
                  header: 'Category',
                  size: '1/2'
                },
                {
                  primary: true,
                  property: 'results',
                  header: 'Results',
                  render: (datum) => {
                    return (
                      <Box>
                        <ul style={{ margin: '0', padding: '0' }}>
                          {
                            (datum?.results?.length > 0) ?
                              datum?.results?.map(i => <StatusGoodSmall color={ACTION_COLOURS[i]} />)
                              : <StatusGoodSmall color={'rgba(0,0,0,0)'} />
                          }
                        </ul>
                      </Box>
                    )
                  },

                },
              ]}
              data={mappedData}
            />

          </Box>
        </Box>
      </div>
    </FrostedGlassBox>
  );
};

export { MetricsSection }